import { reduxKey, FirstTimeFlagsType } from './constants';
import { setFirstTimeFlags, unsetFirstTimeFlag } from './actions';
import { handleActions } from 'redux-actions';

const actionHandlers = handleActions<FirstTimeFlagsType, any>(
  {
    [setFirstTimeFlags.toString()]: (
      state,
      { payload: flags }: ReturnType<typeof setFirstTimeFlags>
    ) => ({ ...state, ...flags }),
    [unsetFirstTimeFlag.toString()]: (
      state,
      { payload: { flag } }: ReturnType<typeof unsetFirstTimeFlag>
    ) => {
      // Set flag to false to indicate it was seen (false = seen, true/undefined = not seen)
      return {
        ...state,
        [flag]: false,
      };
    },
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
